import type { R2BAvailableBrandEntity } from "../../entity_types/r2bAvailableBrand";

export const r2b_available_lf1: R2BAvailableBrandEntity = {
  token: "r2b_available_lf1",
  type: "r2bAvailableBrand",
  name: "Like Family",
  stagingBrandToken: "r2b_staging_like-family",
  benefits: [
    {
      text: "Free Shipping with Insider",
      color: "teal",
    },
    {
      text: "Up to 25% off (5 days left)",
      color: "orange",
    },
    {
      text: "Exclusivity available",
      color: "default",
    },
  ],
  newBadgeIndexes: [0],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
